var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDropDown({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 8,
    viewBox: "0 0 14 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.880761 0.38125C1.38844 -0.126432 2.21156 -0.126432 2.71924 0.38125L7 4.66201L11.2808 0.38125C11.7884 -0.126432 12.6116 -0.126432 13.1192 0.38125C13.6269 0.888931 13.6269 1.71205 13.1192 2.21973L7.91924 7.41973C7.41156 7.92741 6.58844 7.92741 6.08076 7.41973L0.880761 2.21973C0.37308 1.71205 0.37308 0.888931 0.880761 0.38125Z",
    fill: "#4EAAAC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropDown);
export default __webpack_public_path__ + "static/media/drop-down.c9d0a16e.svg";
export { ForwardRef as ReactComponent };